import React from 'react';
import Container from '../container';
import SolutionItem from './SolutionItem';
import RichtextParser from '../../utils/richtext-parser';
import styled, { css } from 'styled-components';
import mq from '../../utils/mq';

const CaseStudySolutionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;
  width: 100%;
  padding: 96px 0;
  ${mq.mobile(css`
    display: flex;
    flex-direction: column;
    padding: 42px 0;
  `)};
`;

const CaseStudySolutionContainer = styled.div`
  grid-column: 2 / span 10;
`;

const LabelContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

const LabelText = styled.div`
  color: #666;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: -0.15px;
`;

const LabelDecoration = styled.div`
  background: #813dff;
  width: 16px;
  height: 2px;
`;

const Title = styled.div`
  color: #161616;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  letter-spacing: -0.72px;
  padding-top: 22px;
  ${mq.mobile(css`
    font-size: 32px;
  `)};
`;

const CaseStudySolutionItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-top: 72px;
`;

const SolutionDescription = styled.div`
  padding-top: 96px;
  color: #666;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.4px;
  ${mq.mobile(css`
    padding-top: 64px;
  `)};
`;

export default function CaseStudySolution({
  title,
  solutionItems,
  solutionDescription
}: {
  title: string;
  solutionItems: any[];
  solutionDescription: any;
}) {
  return (
    <Container>
      <CaseStudySolutionGrid>
        <CaseStudySolutionContainer>
          <LabelContainer>
            <LabelText>The Solution</LabelText>
            <LabelDecoration />
          </LabelContainer>
          <Title>{title}</Title>
          <CaseStudySolutionItems>
            {solutionItems?.map((solutionItem, i) => (
              <SolutionItem
                {...solutionItem}
                key={i}
                leftAligned={i % 2 === 0}
              />
            ))}
          </CaseStudySolutionItems>
          <SolutionDescription
            dangerouslySetInnerHTML={{
              __html: RichtextParser(solutionDescription)
            }}
          />
        </CaseStudySolutionContainer>
      </CaseStudySolutionGrid>
    </Container>
  );
}
